import remote from './remote'

const URL = {
    GET: '/cms/dashboard'
}

export default {
    getDashboard () {
        return remote.request({
            url: remote.getUrl(URL.GET)
        })
    }
}
